var _ = require('underscore');
const narikaDefinition = require('./nr_param_def.js');
const narikaCommon = require('./nr_common.js');

(function () {
    'use strict';

    if (typeof window.narika === 'undefined') {
        var narika = function () {
        };

        if (typeof exports !== 'undefined') {
            exports.narika = narika;
        }

        if (typeof window !== 'undefined') {
            window.narika = narika;
        } else if (typeof global !== 'undefined') {
            global.narika = narika;
        }
    }
    var narika = window.narika;

    var KEY_OF_SCROLL_HEIGHT = '_$scroll_height$*'

    var registerFirstEvent = function () {
        clickSearchButtonEvent();
        selectOrderTypeEvent();
        ignoreSubmitAndExecuteSearchEvent();
    };

    var ignoreSubmitAndExecuteSearchEvent = function () {
        $('#narika_search_form input').on('keydown', function (e) {
            // 改行コードの判定
            if ((e.which && e.which === 13) || (e.keyCode && e.keyCode === 13)) {
                callFirstSearchProductAPI();
                return false; // submit されて、ページが再表示しないように、falseを返す。
            } else {
                return true;
            }
        });
    };

    // REST API に指定する rika.com を示すパラメータ
    // 検索条件を示すクラス
    var SearchCondition = function (keywordList, maxNumber, scope) {
        this.keywordList = keywordList;
        this.maxNumber = Number(maxNumber);
        this.scope = scope;
        this.sortItem = null;
        this.sortOrder = null;
        this.firstIndex = null;
        this.lastIndex = null;
        this.pageNumber = 0; // 0 origin (ページ番号は 0スタートとする)
        this.viewTypeId = null;
    };

    // SerachCondition クラスのインスタンスとして、現在の検索条件を保持するための変数
    var SEARCH_CONDITION = null;
    // 現在の表示している検索結果を保持する変数
    var SEARCH_RESULT = null;

    var callFirstSearchProductAPI = function (keyword, maxNumber, scope, showParams) {

        // 関数の引数に何も設定されていなければ、form から値を取得する
        if (!(keyword != null)) {
            keyword = $('#narika_search_form [name=keyword]').val().trim();
        }
        if (!(maxNumber != null)) {
            maxNumber = $('#narika_search_form [name=max_number]').val();
        }
        if (!(scope != null)) {
            scope = $('#narika_search_form [name=scope]:checked').val();
        }

        if (keyword.length == 0 || isNaN(maxNumber) || (scope != '1' && scope != '0')) {
            $('#narika_search_result_header_area').empty();
            $('#narika_search_result_content_area').empty();
            // 何も入力されていなかったり、表示件数が指定されていなかったら

            $('#narika_search_result_header').hide();
            return; // do nothing
        }

        // 検索結果エリアの表示クリア
        SEARCH_CONDITION = null;

        // 半角及び全角スペースで文字列を区切る。
        var keywordList = keyword.split(/　|\s/);

        var apiUrl = narika.definition.SEARCH_PRODUCTS_API_URL;
        var formParam = {};
        formParam['keywords[]'] = keywordList;
        formParam['items_per_page'] = maxNumber;
        formParam['search_type'] = scope;
        formParam['request_source'] = narika.definition.REQUEST_SOURCE_RIKA;
        formParam['offset'] = 0;

        SEARCH_CONDITION = new SearchCondition(keywordList, maxNumber, scope);

        var selectedOrder = $('.search_result_order').filter('.order_item_flag');
        if (selectedOrder.length > 0) {
            formParam['sort_by'] = $(selectedOrder.get(0)).data('item');
            formParam['sort_order'] = $(selectedOrder.get(0)).data('order');
            SEARCH_CONDITION.sortItem = $(selectedOrder.get(0)).data('item');
            SEARCH_CONDITION.sortOrder = $(selectedOrder.get(0)).data('order');
        }

        narika.common.callRestApi(apiUrl, 'POST', formParam,
            showResult, showParams, null);
    };

    var callFirstSearchFromSearchCondition = function () {

        // Rest API をCall
        callProductAPIBySearchCondition();

        // フォームなどの情報を、SEARCH_CONDITION の内容を元に設定を行う。
        var keyword = '';
        for (var i = 0; i < SEARCH_CONDITION.keywordList.length; i++) {
            if (i > 0) {
                keyword += ' ';
            }
            keyword += SEARCH_CONDITION.keywordList[i];
        }

        $('#narika_search_form [name=keyword]').val(keyword);
        $('#narika_search_form [name=scope]').val([SEARCH_CONDITION.scope]);
        $('#narika_search_form [name=max_number]').val(SEARCH_CONDITION.maxNumber);

        // ソート表示部分の制御
        var $targetSortOrderTag = $('.search_result_order').filter('[data-item="' + SEARCH_CONDITION.sortItem + '"]')
            .filter('[data-order="' + SEARCH_CONDITION.sortOrder + '"]');

        if ($targetSortOrderTag.length > 0) {
            var sortItemText = $targetSortOrderTag.text();
            $('#selected_order_item').text(sortItemText);
        }

        // ソート表示のリストに、アクティブなものに order_item_flag クラスを付与
        $('.search_result_order').removeClass('order_item_flag');
        $targetSortOrderTag.addClass('order_item_flag');
    }

    // 検索ボタンを押下した時の処理
    var clickSearchButtonEvent = function () {
        $('#narika_search_form [name=search_button]').on('click', function () {
            callFirstSearchProductAPI();
        });
    };

    var createAndSetStateUrl = function () {
        var setjson = JSON.stringify(SEARCH_CONDITION);
        var encoded = '?state=' + narika.common.encodeBase64Utf8(setjson);
        history.replaceState('', '', encoded);
        // pushState でも、挙動はするが、動作の仕様が変わってくる。
        // その場合は、popstate 側を実装し、全体的に改修する必要があるかも。
        //history.pushState('', '', encoded);
    };

    ////
    var showResult = function (result, params) {

        // 検索条件をセッションストレージに保存する。
        createAndSetStateUrl();

        if (result == null || result.status != narika.common.SUCCESS || result.body == null) {
            console.log('cannot get data');
            return;
        }

        SEARCH_RESULT = result.body;
        processSearchResultData(SEARCH_RESULT);

        var totalPage = 0;
        if (SEARCH_RESULT.total_count > 1) {
            // 全ページ数の計算
            totalPage = Math.floor(SEARCH_RESULT.total_count / SEARCH_CONDITION.maxNumber) + 1;
        }

        var templateElement = null, templateHtml = null, compiled = null, html = null;

        if (stateParamFlag == true && SEARCH_CONDITION.viewTypeId != null && SEARCH_CONDITION.viewTypeId == 'btn-group-second') {
            $('#btn-group-first').removeClass('active');
            $('#btn-group-second').addClass('active');
        }

        // 非表示にしている部分を表示する
        $('#narika_search_result_header').show();
        var keyword = '';
        for (var i = 0; i < SEARCH_CONDITION.keywordList.length; i++) {
            if (i > 0) {
                keyword += ' ';
            }
            keyword += SEARCH_CONDITION.keywordList[i];
        }
        $('#search_keyword_text').text('"' + keyword + '"');
        // 少し汚いが、この部分だけ HTML含めてJavascriptで中身を作成
        var temp = narika.common.escapeHTML('"' + SEARCH_RESULT.total_count + '件"') +
            '<span class="font-size__18 margin-left__10" id="result_total_page_text">(全' +
            totalPage + 'ページ' +
            ')</span>';
        $('#result_total_count_text').html(temp);

        $('#narika_search_result_content_area').empty();
        // 一覧表示
        drawProductList(SEARCH_RESULT, 'narika_result_list_template', 'narika_search_result_content_area');
        // サムネイル表示
        drawProductList(SEARCH_RESULT, 'narika_result_thumnail_template', 'narika_search_result_content_area');

        // 前ページ、次ページ

        var prev = true, next = true;
        if (SEARCH_RESULT.total_count == 0) {
            prev = false;
            next = false;
        } else {
            if (SEARCH_CONDITION.pageNumber == 0) { // 最初のページだったら
                prev = false;
            }
            var lastNumber = SEARCH_CONDITION.pageNumber * SEARCH_CONDITION.maxNumber +
                SEARCH_RESULT.products.length;
            if (SEARCH_RESULT.total_count <= lastNumber) {
                next = false;
            }
        }

        templateElement = $('#narika_paging_template');
        templateHtml = templateElement.html();
        compiled = _.template(templateHtml);
        html = compiled({
            prev: prev,
            next: next,
            pageNumber: SEARCH_CONDITION.pageNumber + 1,
        });
        $('#narika_search_result_content_area').append(html);

        // 画面トップに移動（但し、戻るボタンから戻ってきた時は除く）
        if (stateParamFlag == true) {
            var scrollY = narika.common.loadFromStorage(KEY_OF_SCROLL_HEIGHT);
            if (scrollY != null) { // 前のY座標のスクロールに移動する
                narika.common.removeInStorage(KEY_OF_SCROLL_HEIGHT);
                scrollY = Number(scrollY);
                // ブラウザの種類によっては、この処理のタイミングで、なぜか描画できていない場合があるので、
                // 意図的にsetTimeoutを使い、別スレッドで処理.
                setTimeout(function () {
                    scrollTo(0, scrollY);
                }, 0);
            }
        } else { // 戻るボタンの時
            scrollTo(0, 0);
        }
        stateParamFlag = false;

        regieterEventsAfterDrawing();
    };

    var regieterEventsAfterDrawing = function () {
        // 描画後にデザイナーが定義したJavascriptを呼び出し、
        // イベント登録処理を行う
        callEventForDesign();
        // ページングのボタンのイベント
        clickPagingButtonEvent();
        // 商品画面に移動する際のイベント
        clickNextPageEvent();
    };

    // 各商品のデータに対して、日本円フォーマットなどの加工処理を行う。
    var processSearchResultData = function (searchResult) {
        if (searchResult.products == null) {
            searchResult.products = new Array();
        }
        var productList = searchResult.products;

        for (var i = 0; i < productList.length; i++) {
            var product = productList[i];

            // 商品ページへのURLの作成
            product.url = PRODUCT_PAGE_URL + '?product_id=' + product.product_id;
            if (product.product_code != null & product.product_code.length > 0
                && product.product_code.indexOf(' ') == -1) { // URLエンコードでエスケープされる文字がある場合は、除外
                product.url = PRODUCT_PAGE_URL + 'detailed/' + product.product_code;
            }
            // 日本円の書式変換
            if (product.tax_exclusive_price != null) {
                product.price_str = narika.common.formatJapaneseYen(product.tax_exclusive_price);
            } else if (product.price != null) {
                // 基本的にはここに来ないはず
                product.price_str = narika.common.formatJapaneseYen(product.price);
            } else {
                // 基本的にはここに来ないはず
                product.price_str = narika.common.formatJapaneseYen(0);
            }
        }
    };

    var callEventForDesign = function () {
        // ==========================================
        // 商品一覧/商品サムネイル　表示切り替え
        // ==========================================
        var $btns = ($('#search-changerbtn-group').find('span'));
        var $first_btn = $('#btn-group-first');
        var $index = $('#search-result-detail-section-index');
        var $thum = $('#search-result-detail-section-thum');
        if (($first_btn).hasClass('active')) {
            $thum.hide();
        } else {
            $index.hide();
        }
        $btns.each(function () {
            $(this).off('click'); // 念の為、イベントクリア
            $(this).on('click', function (e) {
                // ボタン装飾
                if (!$(this).hasClass('active')) {
                    $btns.removeClass('active');
                    $(this).addClass('active');
                }
                // インデックス/サムネイルの表示/非表示切り替え
                if (e.target.id == $first_btn.attr('id')) {
                    $index.fadeIn();
                    $thum.fadeOut();
                } else {
                    $index.fadeOut();
                    $thum.fadeIn();
                }

                if (SEARCH_CONDITION != null) {
                    try {
                        SEARCH_CONDITION.viewTypeId = $(this).attr('id');
                        createAndSetStateUrl();
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        });

        // ==========================================
        // 製品一覧サムネイルマウスオーバー時アクション
        // 製品一覧ページ
        // ==========================================
        var $item = $('.overlayed-item');
        $item.each(function () {
            var $_this = $(this)
            $_this.on('mouseenter', function () {
                $_this.find('.overlay-item').fadeIn();
            });
            $_this.on('mouseleave', function () {
                $_this.find('.overlay-item').fadeOut();
            });
        });
    };

    /**
     * 商品画面に移動した時点でのスクロール量を保存する（戻るボタン時の対処）
     */
    var clickNextPageEvent = function () {
        $('.nr_next_page_click').off('click');
        $('.nr_next_page_click').on('click', function (e) {
            e.preventDefault();
            narika.common.saveInStorage(KEY_OF_SCROLL_HEIGHT, String(window.pageYOffset));
            var url = $(this).attr('href');
            location.href = url;
        });
    };

    /**
     * 次や前ボタンのクリックイベント
     */
    var clickPagingButtonEvent = function () {
        $('#narika_previous_page').off('click');
        $('#narika_next_page').off('click');

        $('#narika_previous_page').on('click', function () {
            if (SEARCH_CONDITION.pageNumber == 0) {
                return;
            }
            SEARCH_CONDITION.pageNumber--;
            callProductAPIBySearchCondition();
        });
        $('#narika_next_page').on('click', function () {
            SEARCH_CONDITION.pageNumber++;
            callProductAPIBySearchCondition();
        });
    };

    var callProductAPIBySearchCondition = function () {
        if (SEARCH_CONDITION == null) {
            // 基本的にはここにはこない。
            return;
        }

        var apiUrl = narika.definition.SEARCH_PRODUCTS_API_URL;
        var formParam = {};
        formParam['keywords[]'] = SEARCH_CONDITION.keywordList;
        formParam['items_per_page'] = SEARCH_CONDITION.maxNumber;
        formParam['search_type'] = SEARCH_CONDITION.scope;
        formParam['request_source'] = narika.definition.REQUEST_SOURCE_RIKA;
        formParam['offset'] = SEARCH_CONDITION.maxNumber * SEARCH_CONDITION.pageNumber;

        if (SEARCH_CONDITION.sortItem != null && SEARCH_CONDITION.sortOrder != null) {
            formParam['sort_by'] = SEARCH_CONDITION.sortItem;
            formParam['sort_order'] = SEARCH_CONDITION.sortOrder;
        }

        narika.common.callRestApi(apiUrl, 'POST', formParam,
            showResult, null, null);
    };

    var narika = window.narika;
    if (typeof narika.page === 'undefined') {
        narika.page = function () {
        };
    }
    narika.page.search = {
    };

    var selectOrderTypeEvent = function () {
        $('.search_result_order').off('click');
        $('.search_result_order').on('click', function () {
            var sortItem = $(this).data('item');
            var sortOrder = $(this).data('order');

            $('.search_result_order').removeClass('order_item_flag');
            // どれが選ばれているかは、class の付与で callFirstSearchProductAPI 内で判断する
            $(this).addClass('order_item_flag');

            // ソートの並び替え時は、formの値ではなく、前回の検索した時の設定を引き継ぐ必要があるため、
            // 引数にSEARCH_CONDITIONの値を入れていることに注意。
            callFirstSearchProductAPI(SEARCH_CONDITION.keyword, SEARCH_CONDITION.maxNumber,
                SEARCH_CONDITION.scope, null);

            // 選択したものを表示
            $('#selected_order_item').text($(this).text());
        });
    };

    var drawProductList = function (searchResult, templateId, drawAreaId) {
        var templateElement = $('#' + templateId);
        var templateHtml = templateElement.html();
        var compiled = _.template(templateHtml);
        var html = compiled({
            'productList': searchResult.products != null ? searchResult.products : new Array(),
        });
        $('#' + drawAreaId).append(html);
    };

    var stateParamFlag;
    var PRODUCT_PAGE_URL = null;
    var SEARCH_PAGE_URL = null;
    var HOME_PAGE_URL = null;
    $(function () { // ready

        if ($('#narika_search_result_content_area').length == 0) {
            // 該当ページで無ければ、何もしない。
            return;
        }

        SEARCH_PAGE_URL = location.href.replace(/\?.*$/, "");
        var slash = SEARCH_PAGE_URL.slice(-1);
        if (slash != '/') {
            SEARCH_PAGE_URL = SEARCH_PAGE_URL + '/'; // 念の為、スラッシュ終わりで統一する
        }
        HOME_PAGE_URL = SEARCH_PAGE_URL + '..';
        PRODUCT_PAGE_URL = SEARCH_PAGE_URL + '../product/';

        registerFirstEvent();

        // バックボタン押されている時は、直前の検索引数を元に問い合わせを行う。
        // var getPrams = (new URL(document.location)).searchParams;
        // var stateParam = getPrams.get('state');
        // var keywordParam = getPrams.get('keyword');

        // IE が searchParams に対応していないので、仕方なく自前で実装
        var stateParam = narika.common.getUrlGetParam('state');
        var keywordParam = narika.common.getUrlGetParam('keyword');
        // 戻るボタン対応
        // state パラメータがGETにあれば、それを処理する
        if (stateParam != null) {
            try {
                var jsonStr = narika.common.decodeBase64Utf8(stateParam);
                var condition = JSON.parse(jsonStr);
                if (condition != null) {
                    stateParamFlag = true;
                    SEARCH_CONDITION = condition;
                    callFirstSearchFromSearchCondition();
                }
            } catch (e) {
                // ユーザ入力エラーもあるので、無視                
            }
        } else if (keywordParam != null) {
            $('#narika_search_form [name=keyword').val(keywordParam);
            callFirstSearchProductAPI(keywordParam);
        }
    });

})();